import { render } from "./CFANav.vue?vue&type=template&id=5bb41ffe&scoped=true"
import script from "./CFANav.vue?vue&type=script&lang=js"
export * from "./CFANav.vue?vue&type=script&lang=js"

import "./CFANav.vue?vue&type=style&index=0&id=5bb41ffe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb41ffe"]])

export default __exports__